/* eslint-disable jsx-a11y/label-has-associated-control */
import styled, {
    SpaceProps,
    TypographyProps,
    LayoutProps,
} from "../../../../shared/styled";

interface IProps extends SpaceProps, TypographyProps, LayoutProps {}

export const StyledLabel = styled(
    ({ mb, display, fontSize, fontWeight, ...rest }) => <label {...rest} />
)<IProps>`
    display: inline-block;
    font-family: IBM Plex Sans;
    font-weight: 500;
`;
